import './app/kernel';

const createWidget = () => {
  const widget = AllianceReseaux.Widget.Instance("Produit", {
    idPanier:"9sn29vY",
    idIntegration:1167,
    langue:"fr",
    ui:"OSMB-125794-1"
  });

  widget.Initialise();
};

document.addEventListener('DOMContentLoaded', () => {

  const scriptElement = document.createElement('script');
  scriptElement.setAttribute('src','//gadget.open-system.fr/widgets-libs/rel/noyau-1.0.min.js');

  const widgetElement = document.createElement('div');
  widgetElement.setAttribute('id', 'widget-produit-OSMB-125794-1');

  const postCatalogElement = document.getElementById('pre-catalog');
  postCatalogElement.appendChild(scriptElement);
  postCatalogElement.appendChild(widgetElement);

  scriptElement.addEventListener('load', () => {
    createWidget();
  });
});
